import { render, staticRenderFns } from "./radiateList.vue?vue&type=template&id=3603f6f1&scoped=true&"
import script from "./radiateList.vue?vue&type=script&lang=js&"
export * from "./radiateList.vue?vue&type=script&lang=js&"
import style0 from "./radiateList.vue?vue&type=style&index=0&id=3603f6f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603f6f1",
  null
  
)

export default component.exports